import Image from "next/image";
import { Fragment } from "react";
import CustomerCard from "../../components/CustomerCard";
import { BASE_ASSETS_URL } from "../../constants/constants";
import Head from "next/head";

// Customer Testimonials
const customerTestimonialsJson = {
  CrumblCookies: {
    customerName: "Crumbl Cookies",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/14.png",
    },
    heading:
      "Crumble Cookies achieved 80% faster approvals with BoloForms' automated workflows.",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        heading:
          "Could you tell us the problem you faced before using BoloForms Approvals?",
      },
      {
        para: "Sarah: As a DTC brand, we have a large team of employees and contractors working remotely across the country. One of our biggest challenges was managing the approval process for various tasks such as employee reimbursements, vendor payments, and time-off requests.",
      },
      {
        para: "Previously, we used to rely on manual processes, which involved sending emails and following up with managers to approve requests. This was a time-consuming and inefficient process, which often led to delayed approvals and missed deadlines.",
      },
      {
        heading: "How has BoloForms Approvals helped you solve these problems?",
      },
      {
        para: "Sarah: BoloForms Approvals has completely transformed the way we manage approvals at Crumble Cookies. The platform's simple form builder allows us to create customized forms for different types of requests, and the ability to connect these forms to complex workflow logics has streamlined our approval process significantly.",
      },
      {
        para: "For instance, when an employee submits a reimbursement request, the form is automatically routed to their manager for approval. If the amount is above a certain threshold, it's then sent to the finance team for further review. The same goes for time-off requests and vendor payments.",
      },
      {
        para: "The dynamic recipients feature has been particularly helpful, as it eliminates the need for us to manually input email addresses. Instead, we can set up the form to automatically send approval requests to the relevant managers based on the employee's department or project. This has reduced the risk of errors and made the process much faster.",
      },
      {
        heading: "What do you think of BoloForms Approvals in general?",
      },
      {
        para: "Sarah: We're extremely satisfied with BoloForms Approvals and would highly recommend it to other DTC brands or businesses with remote teams. The platform has not only made our approval process more efficient, but it's also helped us to keep better track of requests and approvals. Plus, the customer support team has been fantastic in helping us set up the platform and address any issues. Overall, we're very happy with our decision to use BoloForms Approvals.",
      },
    ],
  },
  Leadschool: {
    customerName: "Leadschool",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/2.png",
    },
    heading: "Leadschool moves 30-40% faster with BoloForms Approvals",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        para: "Before we started using BoloForms Approvals, our school's operational processes were a mess. We had to rely on paper forms, emails, and spreadsheets to handle everything from equipment requests to student registrations, and the whole thing was very time-consuming and error-prone.",
      },
      {
        para: "But now, thanks to BoloForms, we've been able to streamline our workflows and save countless hours of administrative work. The simple form builder and the ability to connect the form to complex workflow logics has been a game changer for us.",
      },
      {
        para: "One of the most significant use cases for us has been the equipment request process. In the past, teachers had to fill out paper forms and get them signed by multiple managers before they could get the equipment they needed for their classes. This process was slow and often resulted in delays and miscommunications.",
      },
      {
        para: "With BoloForms, we were able to create a digital form that teachers could fill out online, specifying the equipment they needed and why. Then, the form would automatically be sent to the appropriate managers for approval, with the option to add comments or request additional information. Once everyone had approved the request, the equipment would be ordered and delivered.",
      },
      {
        para: "This process has saved us so much time and effort, and it's also improved our communication and collaboration. The ability to add comments and communicate within the workflow has made it much easier for everyone to stay on the same page and ensure that the equipment is delivered when it's needed.",
      },
      {
        para: "Another use case that has been hugely helpful for us is the student registration process. Before, parents had to fill out paper forms and submit them to the school office, where they would be manually entered into our system. This process was prone to errors, and it often took a long time for us to process all the registrations.",
      },
      {
        para: "With BoloForms, we were able to create a digital form that parents could fill out online, including all the necessary information and documents. The form would automatically be sent to the appropriate managers for review and approval, with the option to ask for more information or reject the registration if necessary. Once approved, the student's information would be automatically entered into our system, and we could generate all the necessary documents and notifications.",
      },
      {
        para: "This process has made our student registration process much more efficient and accurate, and it's also improved our communication with parents. They can now fill out the form from the comfort of their own homes, and they receive notifications and updates throughout the process, which makes them feel more engaged with our school.",
      },
      {
        para: "Overall, BoloForms has been a fantastic tool for us, and I would highly recommend it to any edtech company looking to automate their operational processes. The simple form builder and the ability to connect to complex workflow logics have made it easy for us to streamline our workflows and save time, and the communication and collaboration features have improved our team's productivity and engagement.",
      },
    ],
  },
  Flipkart: {
    customerName: "Flipkart",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/4.png",
    },
    heading: "Flipkart streamlines operations using BoloForms Approvals.",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        para: "As one of the largest logistics and ecommerce companies in India, Flipkart is always looking for ways to improve our operations and serve our customers better. That's why we were so excited when we discovered BoloForms, a powerful workflow automation tool that has helped us streamline our processes and save time and money.",
      },
      {
        para: "One of the most significant use cases for us has been the vendor onboarding process. Before we started using BoloForms, this process was a nightmare. We had to rely on paper forms and manual data entry, which was slow and prone to errors. It often took us weeks or even months to onboard new vendors, which was frustrating for everyone involved.",
      },
      {
        para: "With BoloForms, we were able to create a digital form that vendors could fill out online, including all the necessary information and documents. The form would automatically be sent to the appropriate managers for review and approval, with the option to ask for more information or reject the application if necessary. Once approved, the vendor's information would be automatically entered into our system, and they could start selling on our platform.",
      },
      {
        para: "This process has saved us so much time and effort, and it's also improved our communication with vendors. They can now fill out the form from anywhere and receive notifications and updates throughout the process, which makes them feel more engaged with our platform. Plus, we can now onboard new vendors much faster, which has helped us expand our product offerings and serve our customers better.",
      },
      {
        para: "Another use case that has been hugely helpful for us is the customer service request process. Before, customers had to call or email us to request refunds, returns, or other types of customer service. This process was slow and often resulted in miscommunications or delays.",
      },
      {
        para: "With BoloForms, we were able to create a digital form that customers could fill out online, specifying their request and providing all the necessary information and documents. The form would automatically be sent to the appropriate customer service representatives for review and resolution, with the option to add comments or request additional information. Once the request was resolved, the customer would receive notifications and updates, keeping them informed throughout the process.",
      },
      {
        para: "This process has made our customer service much more efficient and effective, and it's also improved our customers' experience with our platform. They can now request help easily and get fast and accurate resolutions to their issues, which has helped us build trust and loyalty with our customers.",
      },
      {
        para: "Overall, BoloForms has been a fantastic tool for us, and we're so glad we found it. The simple form builder and the ability to connect to complex workflow logics have made it easy for us to streamline our workflows and save time and money, and the communication and collaboration features have improved our team's productivity and engagement. We would highly recommend BoloForms to any logistics or ecommerce company looking to improve their operations and serve their customers better.",
      },
    ],
  },
  MPLAutoGroup: {
    customerName: "MPL Auto Group",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/6.png",
    },
    heading:
      "MPL Autogroup launches more effective employee reimbursements with BoloForms",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        para: "As a large autodealership with over 1000 employees all over the country, we were facing a significant challenge with our reimbursement requests, cash allowances, and leave requests. The process was manual, time-consuming, and prone to errors, which made it challenging to keep track of all the requests and approvals.",
      },
      {
        para: "That's why we turned to BoloForms, a powerful workflow automation tool that has helped us streamline our processes and save time and money. Here are some of the ways BoloForms has helped us become more efficient and productive:",
      },
      {
        paraHeading: "Digital forms for reimbursement requests:",
        para: "Before we started using BoloForms, employees had to fill out paper forms for their reimbursement requests, which were slow and prone to errors. With BoloForms, we were able to create digital forms that employees could fill out online, including all the necessary information and documents. The form would automatically be sent to the appropriate managers for review and approval, with the option to ask for more information or reject the request if necessary. Once approved, the reimbursement would be processed automatically, and the employee would receive their payment in a timely manner.",
      },
      {
        paraHeading: "Automated cash allowances:",
        para: "We also use BoloForms to automate our cash allowance requests. Employees can fill out the form online, including all the necessary information and documents, and the form will automatically be sent to the appropriate managers for review and approval. Once approved, the cash allowance is processed automatically, and the employee receives their payment in a timely manner.",
      },
      {
        paraHeading: "Streamlined leave requests:",
        para: "With BoloForms, we have also streamlined our leave request process. Employees can fill out the form online, specifying the type of leave they need and providing all the necessary information and documents. The form will automatically be sent to the appropriate managers for review and approval, with the option to ask for more information or reject the request if necessary. Once approved, the leave is automatically entered into our system, and the employee's schedule is updated accordingly.",
      },
      {
        paraHeading: "Real-time tracking and reporting:",
        para: "With BoloForms, we can track all our requests and approvals in real-time, which has helped us stay on top of our operations and identify areas for improvement. We can also generate reports and analytics on our workflows, which has helped us optimize our processes and save time and money.",
      },
      {
        para: "Overall, BoloForms has been a fantastic tool for us, and we're so glad we found it. The simple form builder and the ability to connect to complex workflow logics have made it easy for us to streamline our workflows and save time and money, and the communication and collaboration features have improved our team's productivity and engagement. We would highly recommend BoloForms to any autodealership looking to automate their processes and serve their employees better.",
      },
    ],
  },
  Airasia: {
    customerName: "Airasia",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/8.png",
    },
    heading: "Airasia drives global collaboration with BoloForms",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        para: "At AirAsia, we have a global workforce spread across multiple countries and departments, which makes it challenging to streamline our approval processes. We were facing a significant challenge in managing approvals for various requests, including reimbursements, leave requests, and travel requests, among others. We needed a solution that could help us automate our processes, save time and money, and ensure smooth communication and collaboration across teams and departments.",
      },
      {
        para: "That's when we turned to BoloForms, a powerful workflow automation tool that has helped us streamline our approval processes and enhance our operations. Here are some of the ways BoloForms has helped us become more efficient and productive:",
      },
      {
        paraHeading: "Dynamic recipients feature:",
        para: "One of the most significant challenges we faced was the inability to specify the right recipient for each request. With BoloForms' dynamic recipients feature, we can now ask users to fill in relevant information such as employee ID or department name, and the recipient will be automatically selected based on that information. This has helped us ensure that the right person is receiving each request for approval, and it has eliminated any confusion or delays in the approval process",
      },
      {
        paraHeading: "Lookup table functionality:",
        para: "Another challenge we faced was the need to have a centralized repository of email IDs for all the managers and supervisors who need to approve various requests. With BoloForms' lookup table functionality, we can now create a Google sheet with a list of employee IDs and their corresponding email IDs, and use that sheet as a reference for all the approval emails. This has helped us streamline the approval process and ensure that each request is sent to the right person.",
      },
      {
        paraHeading: "Real-time tracking and reporting:",
        para: "With BoloForms, we can track all our requests and approvals in real-time, which has helped us stay on top of our operations and identify areas for improvement. We can also generate reports and analytics on our workflows, which has helped us optimize our processes and save time and money.",
      },
      {
        paraHeading: "Customizable forms and workflows:",
        para: "With BoloForms' simple form builder and the ability to connect to complex workflow logics, we can create custom forms and workflows that meet our specific needs and requirements. This has helped us streamline our approval processes and improve our team's productivity and engagement.",
      },
      {
        para: "Overall, BoloForms has been a fantastic tool for us, and we're so glad we found it. The dynamic recipients feature and lookup table functionality have made it easy for us to streamline our approval processes and ensure smooth communication and collaboration across teams and departments. We would highly recommend BoloForms to any organization looking to automate their approval processes and improve their operations.",
      },
    ],
  },
  SayaStationery: {
    customerName: "Saya Stationery",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/10.png",
    },
    heading:
      "Saya Stationary finds a better way to build and grow with BoloForms",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        para: "As a small business owner, I wear many hats, including managing various vendors and employees who submit requests for reimbursements, leave, and cash allowances. With a growing number of employees, managing these requests can quickly become overwhelming, which is why I was excited to discover BoloForms.",
      },
      {
        para: "BoloForms' dynamic recipients feature and lookup table functionality have been a game-changer for our small business, helping us automate our approval processes and streamline our operations. Here are some of the ways BoloForms has helped us:",
      },
      {
        paraHeading: "Dynamic recipients feature:",
        para: "With BoloForms' dynamic recipients feature, we can now ask users to fill in relevant information such as their department, manager's name, or project code, and BoloForms will automatically send the approval request to the right person. This has helped us eliminate any confusion or delays in the approval process, and it has ensured that each request is routed to the appropriate approver.",
      },
      {
        paraHeading: "Lookup table functionality:",
        para: "Another challenge we faced was the need to have a centralized repository of email IDs for all our vendors and employees who need to request approvals. With BoloForms' lookup table functionality, we can now create a spreadsheet that lists all the departments, projects, or vendors and their corresponding email IDs. BoloForms automatically looks up the email of the approver based on the information provided by the requester, ensuring that the approval request goes to the correct person.",
      },
      {
        para: "Customizable forms and workflows: With BoloForms' simple form builder and the ability to connect to complex workflow logics, we can create custom forms and workflows that meet our specific needs and requirements. This has helped us streamline our approval processes and improve our team's productivity and engagement.",
      },
      {
        para: "Real-time tracking and reporting: BoloForms' real-time tracking and reporting have made it easy for us to monitor our approval processes, identify bottlenecks, and optimize our workflows. With BoloForms, we can generate reports and analytics on our workflows, which has helped us improve our processes and make data-driven decisions.",
      },
      {
        para: "Overall, BoloForms has been a fantastic tool for our small business, and we're so glad we found it. The dynamic recipients feature and lookup table functionality have made it easy for us to streamline our approval processes and ensure smooth communication and collaboration with our vendors and employees. We would highly recommend BoloForms to any small business looking to automate their approval processes and improve their operations.",
      },
    ],
  },
  XPOLogistics: {
    customerName: "XPO Logistics",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/12.png",
    },
    heading:
      "XPO Logistics optimizes workflows and tightens security with BoloForms",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        heading:
          "Could you tell us about the challenges you were facing before using BoloForms Approvals for your operational processes?",
        para: "Before using BoloForms Approvals, our company's operational processes were extremely manual and time-consuming. We were using a combination of paper forms, emails, and spreadsheets to manage reimbursement requests, cash allowances, and leave requests for our 100+ employees spread out all over the country. This led to errors, delays, and miscommunications, and made it difficult for us to track and manage all the requests.",
      },
      {
        heading: "How did BoloForms Approvals help you solve those challenges?",
        para: "BoloForms Approvals was a game-changer for us. With its simple form builder and the ability to connect the form to complex workflow logics, we were able to automate the entire process from start to finish. Employees could easily submit requests through the form, and it would automatically route to the appropriate managers for approvals. The dynamic recipients feature and lookup table also made it easy for us to ensure that the right people were being notified at each step of the process. This streamlined the entire process and eliminated errors and delays.",
      },
      {
        heading:
          "What are some specific use cases where BoloForms Approvals has helped your company?",
        para: "We've seen significant improvements across the board since implementing BoloForms Approvals. Some specific use cases include:",
      },
      {
        para: "Reimbursement requests: Employees can now easily submit reimbursement requests through the form, and the form automatically routes to the appropriate manager for approval. This has significantly reduced the time it takes to process reimbursements and eliminated errors in the process.",
      },
      {
        paraHeading: "Cash allowances:",
        para: "We use the form to manage cash allowances for our employees, and BoloForms Approvals has made it easy to track and manage these requests. The form automatically routes to the appropriate manager for approval, and we can easily track the status of each request.",
      },
      {
        paraHeading: "Leave requests:",
        para: "Employees can now submit leave requests through the form, and it automatically routes to the appropriate manager for approval. This has made it easy to manage employee leave and ensure that we have the appropriate coverage at all times.",
      },
      {
        heading:
          "What has been your overall experience with BoloForms Approvals?",
        para: "Our experience with BoloForms Approvals has been extremely positive. The tool is easy to use, and the support team has been very responsive to our needs. We've seen significant improvements in our operational processes, and we're able to manage requests more efficiently and effectively. We would highly recommend BoloForms Approvals to any company looking to streamline their operational processes.",
      },
    ],
  },
  GreatLakesAceHardware: {
    customerName: "Great Lakes Ace Hardware",
    banner: {
      color: "#f8f7f6",
      imgSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/16.png",
    },
    heading:
      "Great Lakes Ace Hardware aligns its nationwide operational team with BoloForms",
    wrritenBy: {
      name: "Vidya Tiwari",
      profileImg: `${BASE_ASSETS_URL}/customers/author.png`,
      desc: "Vidya Tiwari is the Content Marketing Manager at BoloForms, a startup that provides powerful, yet simple, form-based approval building solutions. With a flair for creating content that resonates with readers and sparks engagement, Vidya has written for a range of audiences, from small businesses to enterprise-level organizations. She excels at creating engaging content for various audiences and enjoys reading, cooking, yoga, hiking, and volunteering. You can connect with her through her contact",
    },
    writtenOn: "January 20, 2023",
    content: [
      {
        heading: "What were the challenges you faced before using BoloForms?",
        para: "Chris: We had a lot of manual processes for approvals which were causing delays and inefficiencies. We were constantly exchanging emails and phone calls trying to get approvals from different people",
      },
      {
        heading: "How has BoloForms helped you solve those challenges?",
        para: "Chris: BoloForms has been a game-changer for us. We have been able to streamline our approval processes and reduce the time it takes to get approvals. We now use BoloForms for everything from purchase requests to expense reports.",
      },
      {
        para: "The dynamic recipient feature has been particularly helpful in getting approvals from the right people without having to manually track down their email addresses or phone numbers. We have also been able to customize our forms and workflows to fit our specific needs.",
      },
      {
        heading: "What benefits have you seen since using BoloForms?",
        para: "Chris: We have seen a significant reduction in the amount of time it takes to get approvals. On average, we are saving about 5 hours per person per week. This has allowed us to be more efficient and productive with our time. We have also been able to reduce errors and ensure that everything is properly approved and documented.",
      },
      {
        heading: "What would you say to other companies considering BoloForms?",
        para: "Chris: I would highly recommend BoloForms to any company looking to streamline their approval processes. The platform is easy to use and has helped us save a significant amount of time and resources. The customer support team has also been very helpful in answering any questions we have had along the way.",
      },
    ],
  },
};

async function getCustomerTestimonial(customer) {
  let posts = {};
  await new Promise((resolve, reject) => {
    posts = customerTestimonialsJson[customer];
    resolve(posts);
  });
  return posts;
}

export const getStaticProps = async ({ params }) => {
  const customerTestimonial = await getCustomerTestimonial(
    params.customer.toString().replaceAll(" ", "")
  );
  return {
    props: { customerTestimonial },
  };
};

export const getStaticPaths = async () => {
  const customerTestimonials = Object.keys(customerTestimonialsJson);
  let paths = [];
  customerTestimonials.forEach((customerTestimonial) => {
    paths.push({ params: { customer: customerTestimonial } });
  });
  return {
    paths: paths,
    fallback: true,
  };
};

const Customer = ({ customerTestimonial }) => {
  // Customer Testimonial Cards Data
  let customerCardJson = [
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/13.png",
      customerName: "Crumbl Cookies",
      bgColor: "bg-green-100/50",
      customerDescription:
        "Discover how Crumble Cookies achieved 80% faster approvals with BoloForms automated workflows.",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/1.png",
      customerName: "Leadschool",
      bgColor: "bg-red-100/50",
      customerDescription:
        "Leadschool moves 30-40% faster with BoloForms Approvals",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/3.png",
      customerName: "Flipkart",
      bgColor: "bg-yellow-100/50",
      customerDescription:
        "Flipkart streamlines operations using BoloForms Approvals.",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/5.png",
      customerName: "MPL AutoGroup",
      bgColor: "bg-pink-100/50",
      customerDescription:
        "MPL Autogroup launches more effective employee reimbursements with BoloForms",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/7.png",
      customerName: "Airasia",
      bgColor: "bg-orange-100/50",
      customerDescription: "Airasia drives global collaboration with BoloForms",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/9.png",
      customerName: "Saya Stationery",
      bgColor: "bg-green-100/50",
      customerDescription:
        "Saya Stationary finds a better way to build and grow with BoloForms",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/11.png",
      customerName: "XPO Logistics",
      bgColor: "bg-yellow-100/50",
      customerDescription:
        "XPO Logistics optimizes workflows and tightens security with BoloForms",
    },
    {
      imageSrc:
        "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/customer-testimonial/15.png",
      customerName: "Great Lakes Ace Hardware",
      bgColor: "bg-green-100/50",
      customerDescription:
        "Great Lakes Ace Hardware aligns its nationwide operational team with BoloForms",
    },
  ];
  customerCardJson = customerCardJson.filter(
    (customerCard) =>
      customerCard?.customerName !== customerTestimonial?.customerName
  );
  return (
    <div className="w-full flex flex-col justify-center items-center mt-20 md:mt-36">
      <Head>
        <meta charSet="utf-8" />
        <title>{`BoloSign Customer | ${customerTestimonial?.customerName}`}</title>
        <meta
          name="description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta name="geo.region" content="IN" />
        <meta name="geo.position" content="22.351115;78.667743" />
        <meta name="ICBM" content="22.351115, 78.667743" />
        <meta name="author" content="BoloSign" />
        <meta name="publisher" content="BoloSign " />
        <meta
          name="robots"
          content="INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
        />
        <link
          rel="canonical"
          href={`https://www.bolosign.com/customers/${customerTestimonial?.customerName}`}
        />

        <meta
          property="og:url"
          content={`https://www.bolosign.com/customers/${customerTestimonial?.customerName}`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content={`BoloSign Customer | ${customerTestimonial?.customerName}`}
        />
        <meta
          property="og:description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta
          property="og:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="https://bolosign.com" />
        <meta
          property="twitter:url"
          content={`https://www.bolosign.com/customers/${customerTestimonial?.customerName}`}
        />
        <meta
          name="twitter:title"
          content="How to Create Google Forms Approval Workflow - BoloSign"
        />
        <meta
          name="twitter:description"
          content="BoloSign helps you automate your Workflow With Google Forms. With BoloSign, you can create custom forms & manage your data easily. Get started today!"
        />
        <meta
          name="twitter:image"
          content="https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
        />
      </Head>
      {customerTestimonial ? (
        <>
          <div
            // style={{ background: customerTestimonial.banner.color }}
            className="w-full max-w-screen-lg mx-auto  h-full relative flex justify-center items-center"
          >
            <div className="w-full h-full sm:h-full flex justify-center items-center">
              <Image
                width="700"
                height="342"
                key="bannerImg"
                className="w-full h-full text-center removeBg"
                src={customerTestimonial.banner.imgSrc}
                alt="banner"
                loading="eager"
              />
            </div>
          </div>
          <div className="md:mt-12 max-w-screen-lg mx-auto ">
            <h1 className="text-2xl md:text-5xl sm:text-4xl font-semibold leading-normal mt-10">
              {customerTestimonial.heading}
            </h1>
            <div className="w-full flex justify-between items-center mt-3 mb-8">
              <div className="w-full flex justify-start items-center gap-3">
                <div className="w-10 h-10 flex justify-center items-center rounded-full overflow-hidden">
                  <Image
                    key="profileImg"
                    src={customerTestimonial.wrritenBy.profileImg}
                    className="w-full h-full rounded-full object-cover"
                    width={10}
                    height={10}
                    alt="profile"
                  />
                </div>
                <p className="text-base">
                  {/* <span className="text-[#a97dff]">by </span>{" "} */}
                  {customerTestimonial.wrritenBy.name}
                  {/* </p>
                <p className="text-base font-semibold"> */}
                  {", "}
                  {customerTestimonial.writtenOn}
                </p>
              </div>
              <div className="flex justify-center items-start ml-3"></div>
            </div>
            {customerTestimonial.content.map((info, index) => (
              <Fragment key={index}>
                {info?.heading && (
                  <h3
                    key={"heading" + index}
                    className="text-xl md:text-2xl leading-normal text-black font-semibold mt-5 md:mt-12"
                  >
                    {info.heading}
                  </h3>
                )}
                {info?.quote && (
                  <div
                    key={"quote" + index}
                    className="w-full flex flex-col justify-center items-end mt-5"
                  >
                    <h3 className="w-full text-lg text-center font-semibold italic leading-relaxed text-black">
                      <span className="text-2xl text-[#915bff]">&quot;</span>
                      {info.quote}
                      <span className="text-2xl text-[#915bff]">&quot;</span>
                    </h3>
                    <h3 className="text-lg flex justify-center items-center text-gray-600 pr-6 sm:pr-20 mt-3">
                      <span className="h-[3px] w-5 bg-[#915bff] block mr-2"></span>
                      {info.quoteBy}
                    </h3>
                  </div>
                )}
                {info?.para && (
                  <p
                    key={"para" + index}
                    className="text-base md:text-lg my-4 text-gray-900"
                  >
                    {info?.paraHeading && (
                      <span className="capitalize font-semibold text-lg my-4 text-black">
                        {info?.paraHeading}{" "}
                      </span>
                    )}
                    {info.para}
                  </p>
                )}
                {}
                {info?.tags && info?.tags.length > 0 && (
                  <div
                    key={"tags" + index}
                    className="w-full flex flex-wrap justify-start items-center gap-2 mt-4"
                  >
                    {info.tags.map((tag, index) => (
                      <div
                        key={"tag" + index}
                        className="px-4 py-2 bg-[#915bff] text-white font-semibold rounded-lg"
                      >
                        {tag}
                      </div>
                    ))}
                  </div>
                )}
                {info?.imgSrc && (
                  <div
                    key={"img" + index}
                    className="w-full flex justify-center items-center mt-6"
                  >
                    <Image
                      src={info.imgSrc}
                      width="800"
                      height="400"
                      loading="lazy"
                      alt=""
                      className="w-full sm:w-fit mt-4"
                    />
                  </div>
                )}
              </Fragment>
            ))}
            <div className="w-full mt-20">
              <div className="w-full flex justify-center items-center">
                <span className="w-full h-[2px] bg-[#915bff]"></span>
                <h3 className="text-lg font-semibold mx-4 text-gray-900">
                  Author
                </h3>
                <span className="w-full h-[2px] bg-[#915bff]"></span>
              </div>
              <div className="w-full flex flex-col sm:flex-row justify-center items-center mt-10 sm:gap-10">
                <div className="w-full sm:w-fit flex justify-start items-center gap-5">
                  <div className="w-12 sm:w-28 h-12 sm:h-28">
                    <div className="w-full sm:w-28 h-full sm:h-28 flex justify-center items-center rounded-full overflow-hidden">
                      <Image
                        src={customerTestimonial.wrritenBy.profileImg}
                        className="w-full h-full object-cover"
                        width={10}
                        height={10}
                        alt="profile"
                        key="profileImgBottom"
                      />
                    </div>
                  </div>
                  <h3 className="text-lg sm:hidden font-semibold">
                    {customerTestimonial.wrritenBy.name}
                  </h3>
                </div>
                <div className="flex flex-col justify-center items-start mt-5">
                  <p className="hidden sm:block text-lg font-semibold">
                    {customerTestimonial.wrritenBy.name}
                  </p>
                  <p className="text-base  text-gray-900">
                    {customerTestimonial.wrritenBy.desc}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="w-full max-w-screen-mxl mx-auto flex justify-center items-center">
          <h3 className="text-2xl font-semibold my-10">Customer Not Found</h3>
        </div>
      )}
      <span className="w-full max-w-screen-mxl mx-auto border-t-2 border-[#915bff] block bg- mt-20"></span>
      <h3 className="text-xl md:text-2xl text-center font-semibold mt-10">
        RECOMMENDED ARTICLES
      </h3>
      <div className="w-full flex justify-center items-center mt-10">
        <div className="w-full max-w-screen-xl mx-auto grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 place-items-center gap-[20px]">
          {/* <div className="w-full overflow-x-scroll flex justify-center items-center gap-5 p-10 snap-x"> */}
          {customerCardJson.slice(0, 3).map((customer, index) => (
            <CustomerCard key={index} {...customer} />
          ))}
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default Customer;
